//
const getAccount = async () => {
  //メタマスクがインストールされているか
  if (window.ethereum == null) {
    //メタマスクページへ飛ばす
    //window.open('https://metamask.io/', '_blank');
    return 'noinstall';
  }

  try {
    const account = await window.ethereum.request({ method: 'eth_requestAccounts' });
    if (account.length > 0) {
      return account[0];
    } else {
      return null;
    }
  } catch (err) {
    if (err.code === 4001) {
      //ユーザーにリクエストを拒否された
      console.log('Please connect to MetaMask.');
    } else {
      console.error(err);
    }
    return null;
  }
};

//サインを取得 (https://eliteionic.com/tutorials/creating-web3-login-with-ethereum-metamask-firebase-auth/)
const getSign = async (nonce, address) => {
  try {
    const signText = await window.ethereum.request({
      method: 'personal_sign',
      params: [`0x${toHex(nonce)}`, address], //'0x4db276b07389057ceb03a2eca1c5bdb3f9927dfd'
    });
    return signText;
  } catch (err) {
    if (err.code === 4001) {
      //ユーザーにリクエストを拒否された
      console.log('Please connect to MetaMask.');
    } else {
      console.error(err);
    }
    return null;
  }
};

function toHex(stringToConvert) {
  return stringToConvert
    .split('')
    .map((c) => c.charCodeAt(0).toString(16).padStart(2, '0'))
    .join('');
}

//メタマスクの接続状況を確認
async function checkAccount() {
  return window.ethereum
    .request({ method: 'eth_accounts' })
    .then((data) => {
      console.log(data);
      if (data.length > 0) {
        return data[0];
      } else {
        return null;
      }
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
}

//各チェーン名
const Chains = {
  1: 'Mainnet',
  3: 'Ropsten',
  4: 'Rinkeby',
  42: 'Kovan',
  1337: 'Geth private chain(default )',
  61: 'Ethereum Classic Mainnet',
  62: 'Morden',
};

const getChainName = async () => {
  const chainId = await window.ethereum.request({ method: 'eth_chainId' });
  return Chains[parseInt(chainId)];
};

export default { getAccount, checkAccount, getChainName, getSign };
